import { useQuery } from "@tanstack/react-query"
import { settingsWhatsappNumbersQuery } from "modules/settings/lib/whatsapp/settingsWhatsappNumbersQuery"

export function useSettingsWhatsappNumbersQuery(
  ...args: Parameters<typeof settingsWhatsappNumbersQuery>
) {
  return useQuery(settingsWhatsappNumbersQuery(...args))
}
